import { ToggleEnum, UserType } from 'common/common.types';

const useFlag = (state: UserType, toggles: ToggleEnum[]): boolean =>
  toggles.some(toggle => toggle in state.ldToggles && state.ldToggles[toggle]);

export default useFlag;
